import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/button';
import { Phone } from 'lucide-react';
import { WhatsAppIcon } from './WhatsAppIcon';
import { phoneRaw } from '../data/menuData';

const FOOTER_INITIAL = { opacity: 0, y: 20 };
const FOOTER_ANIMATE = { opacity: 1, y: 0 };
const FOOTER_TRANSITION = { delay: 0.2 };
const BUTTON_HOVER = { scale: 1.02 };
const BUTTON_TAP = { scale: 0.98 };

export const CartFooter = ({ whatsappUrl, sendOrderText, callText }) => (
  <motion.div
    initial={FOOTER_INITIAL}
    animate={FOOTER_ANIMATE}
    transition={FOOTER_TRANSITION}
    className="pt-6 space-y-3 border-t border-border mt-6"
  >
    <Button
      asChild
      className="w-full rounded-full py-6 text-base font-semibold"
      data-testid="whatsapp-order-btn"
    >
      <motion.a
        whileHover={BUTTON_HOVER}
        whileTap={BUTTON_TAP}
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        <WhatsAppIcon />
        {sendOrderText}
      </motion.a>
    </Button>
    <Button
      asChild
      variant="outline"
      className="w-full rounded-full py-6 text-base font-semibold"
      data-testid="call-restaurant-btn"
    >
      <motion.a
        whileHover={BUTTON_HOVER}
        whileTap={BUTTON_TAP}
        href={`tel:${phoneRaw}`}
      >
        <Phone className="mr-2 h-5 w-5" />
        {callText}
      </motion.a>
    </Button>
  </motion.div>
);
